<form id="busy-form" action="#" method="POST" soho-busyindicator
    [transparentOverlay]="transparentOverlay" [blockUI]="true" [text]="message" [displayDelay]="delay"
    autocomplete="off">
    <div id="notification">
    </div>
    <div class="row" style="padding-top:1%; padding-left:1%;">
        <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
    </div>
    <div class="row">
        <div class="twelve columns">
            <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
                <div class="row top-padding">
                    <div class="field" id="divroletype">
                        <label id="tblroletype" class="required" for="roletype">Role Type</label>
                        <input id="roletype" name="roletype" type="text" data-validate="required" soho-input
                            placeholder="e.g. Business Development Representative" (click)="RemoveError('roletype')"
                            [(ngModel)]="model.roletype" />
                    </div>
                </div>
                <div class="field" id="divplantype">
                    <label id="tblplantype" class="required" for="plantype">Plan Type</label>
                    <input id="plantype" name="plantype" type="text" data-validate="required" soho-input
                        placeholder="e.g. 2026 Business Development Rep Plan" (click)="RemoveError('plantype')"
                        [(ngModel)]="model.plantype" />
                </div>
            </div>
        </div>
        <div class="row" id="AddDetails" style="text-align: center;padding-top: 2%;" class=" twelve columns">
            <button class="btn-primary hide-focus" type="button" title="SaveMapping" (click)="SaveMapping()">Save</button>&nbsp;
            <button class="btn-secondary hide-focus" type="button" title="Cancel" (click)="Cancel()">Cancel</button>
        </div>
    </div>
</form>
